var faqListHeight = 0;

document.addEventListener(
    "DOMContentLoaded", () => {

        document.querySelectorAll('.faq-item .faq-title').forEach((item) => {
            item.addEventListener('click', (event) => toggleFaqItem(event));
        });
    }
);

function toggleFaqItem(event) {
    event.preventDefault();

    // get the parent node of the clicked title element which should be the faq-item container
    var currentTarget = event.currentTarget.parentNode;

    var expandingContent = currentTarget.querySelector('.faq-content');
    var expandingContentInner = currentTarget.querySelector('.faq-content-inner');

    if (currentTarget.classList.contains('active')) {
        currentTarget.classList.remove('active');
        expandingContent.style.height = 0;
        faqListHeight -= expandingContentInner.offsetHeight - 10;
    } else {
        currentTarget.classList.add('active');
        expandingContent.style.height = expandingContentInner.offsetHeight + 10 + 'px';

        faqListHeight += expandingContentInner.offsetHeight + 10;
    }

    // we only need to adjust the height of the container if the list of questions is in the collapseable container so find container within the toggle class added when this is the case
    var faqList = document.querySelector('.toggle-faqs .faq-list');
    if (faqList) {
        faqList.style.height = faqListHeight + 'px';
    }
}
